import React, { useEffect, useState } from "react";
import { Table, Spinner, Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { fetchEventsByProject, fetchEventDetails } from "../Api/ViewEvent";
import { Link } from "react-router-dom";

const ProjectEvents = ({ orgId, projectId }) => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const loadEvents = async () => {
    if (!orgId || !projectId) return;

    try {
      setLoading(true);

      const data = await fetchEventsByProject(orgId, projectId);
      console.log("Fetched Events:", data);

      const eventList = data?.map((item) => item.event) || [];
      setEvents(eventList);
    } catch (error) {
      console.error(error);
      toast.error("Failed to load events");
    } finally {
      setLoading(false);
    }
  };

  //   const handleView = async (eventCode) => {
  //     try {
  //       const data = await fetchEventByCode(orgId, eventCode);
  //       setSelectedEvent(data);
  //       setShowModal(true);
  //     } catch (error) {
  //       toast.error("Error fetching event details");
  //     }
  //   };

  const handleView = async (eventCode) => {
    try {
      const data = await fetchEventDetails(eventCode);
      setSelectedEvent(data);
      setShowModal(true);
    } catch (error) {
      toast.error("Error fetching event details");
    }
  };

  const handleConvertToTask = (event) => {
    navigate(`/addTask?projectId=${projectId}&eventCode=${event.eventCode}`);
  };

  useEffect(() => {
    loadEvents();
  }, [orgId, projectId]);

  if (loading) {
    return (
      <div className="text-center p-4">
        <Spinner animation="border" />
      </div>
    );
  }

  return (
    <div>
      <h5 className="mb-3">Project Events</h5>

      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>Event Code</th>
            <th>Event Name</th>
            <th>Type</th>
            <th>Organizer</th>
            <th>Location</th>
            <th>Start Date</th>
            <th>End Date</th>
            <th>Status</th>
            <th style={{ textAlign: "center" }}>Action</th>
          </tr>
        </thead>

        <tbody>
          {events.length === 0 ? (
            <tr>
              <td colSpan="9" className="text-center">
                No events found
              </td>
            </tr>
          ) : (
            events?.filter(Boolean).map((event) => (
              <tr key={event?.eventCode}>
                {" "}
                <td>{event.eventCode}</td>
                <td>{event.eventName}</td>
                <td>{event.eventType}</td>
                <td>{event.organizerName}</td>
                <td>{event.eventLocation}</td>
                <td>
                  {event.eventDate
                    ? moment(event.eventDate).format("DD MMM YYYY")
                    : "-"}
                </td>
                <td>
                  {event.eventEndDate
                    ? moment(event.eventEndDate).format("DD MMM YYYY")
                    : "-"}
                </td>
                <td>{event.eventStatus}</td>
                <td style={{ textAlign: "center" }}>
                  <div
                    style={{
                      display: "flex",
                      gap: "6px",
                      justifyContent: "center",
                    }}
                  >
                    <Button
                      size="sm"
                      variant="info"
                      onClick={() => handleView(event.eventCode)}
                    >
                      View
                    </Button>

                    <Button
                      as={Link}
                      to={`/editEvent/${event.eventCode}`}
                      size="sm"
                      variant="warning"
                    >
                      Edit
                    </Button>

                    <Button
                      size="sm"
                      variant="primary"
                      onClick={() => handleConvertToTask(event)}
                    >
                      Convert to Task
                    </Button>
                  </div>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Event Details</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {selectedEvent && (
            <>
              {/* EVENT OVERVIEW */}

              <h6 className="mb-2">Event Overview</h6>

              <Table bordered size="sm">
                <tbody>
                  <tr>
                    <td>
                      <b>Event Code</b>
                    </td>
                    <td>{selectedEvent?.event?.eventCode}</td>
                    <td>
                      <b>Event Name</b>
                    </td>
                    <td>{selectedEvent?.event?.eventName}</td>
                  </tr>

                  <tr>
                    <td>
                      <b>Type</b>
                    </td>
                    <td>{selectedEvent?.event?.eventType}</td>
                    <td>
                      <b>Status</b>
                    </td>
                    <td>{selectedEvent?.event?.eventStatus}</td>
                  </tr>

                  <tr>
                    <td>
                      <b>Organizer</b>
                    </td>
                    <td>{selectedEvent?.event?.organizerName}</td>
                    <td>
                      <b>Department</b>
                    </td>
                    <td>{selectedEvent?.event?.department}</td>
                  </tr>

                  <tr>
                    <td>
                      <b>Location</b>
                    </td>
                    <td>{selectedEvent?.event?.eventLocation}</td>
                    <td>
                      <b>Budget</b>
                    </td>
                    <td>{selectedEvent?.event?.budgetAllocation}</td>
                  </tr>

                  <tr>
                    <td>
                      <b>Start Date</b>
                    </td>
                    <td>
                      {moment(selectedEvent?.event?.eventDate).format(
                        "DD MMM YYYY",
                      )}
                    </td>

                    <td>
                      <b>End Date</b>
                    </td>
                    <td>
                      {selectedEvent?.event?.eventEndDate
                        ? moment(selectedEvent?.event?.eventEndDate).format(
                            "DD MMM YYYY",
                          )
                        : "-"}
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <b>Description</b>
                    </td>
                    <td colSpan="3">
                      {selectedEvent?.event?.eventDescription || "-"}
                    </td>
                  </tr>
                </tbody>
              </Table>

              {/* PARTICIPANTS */}

              <h6 className="mt-4">Participants</h6>

              <Table bordered size="sm">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>User Id</th>
                    <th>Role</th>
                    <th>Status</th>
                  </tr>
                </thead>

                <tbody>
                  {selectedEvent.Participants?.length > 0 ? (
                    selectedEvent.Participants.map((p, index) => (
                      <tr key={p.participantGuid}>
                        <td>{index + 1}</td>
                        <td>{p.userId}</td>
                        <td>{p.participantRole}</td>
                        <td>{p.status}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="text-center">
                        No participants
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>

              {/* REMINDERS */}

              <h6 className="mt-4">Reminders</h6>

              <Table bordered size="sm">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Minutes</th>
                    <th>Type</th>
                    <th>Sent</th>
                  </tr>
                </thead>

                <tbody>
                  {selectedEvent.Reminders?.length > 0 ? (
                    selectedEvent.Reminders.map((r, index) => (
                      <tr key={r.reminderGuid}>
                        <td>{index + 1}</td>
                        <td>{r.reminderMinutes}</td>
                        <td>{r.reminderType}</td>
                        <td>{r.isSent ? "Yes" : "No"}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="text-center">
                        No reminders
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>

              {/* MOM */}

              <h6 className="mt-4">Minutes Of Meeting</h6>

              {selectedEvent.MinutesOfMeeting ? (
                <Table bordered size="sm">
                  <tbody>
                    <tr>
                      <td>
                        <b>Prepared By</b>
                      </td>
                      <td>{selectedEvent.MinutesOfMeeting.preparedBy}</td>
                    </tr>

                    <tr>
                      <td>
                        <b>Approved By</b>
                      </td>
                      <td>{selectedEvent.MinutesOfMeeting.approvedBy}</td>
                    </tr>

                    <tr>
                      <td>
                        <b>Discussion</b>
                      </td>
                      <td>{selectedEvent.MinutesOfMeeting.discussionPoints}</td>
                    </tr>

                    <tr>
                      <td>
                        <b>Decisions</b>
                      </td>
                      <td>{selectedEvent.MinutesOfMeeting.decisionsTaken}</td>
                    </tr>

                    <tr>
                      <td>
                        <b>Action Items</b>
                      </td>
                      <td>{selectedEvent.MinutesOfMeeting.actionItems}</td>
                    </tr>
                  </tbody>
                </Table>
              ) : (
                <p>No Minutes of Meeting</p>
              )}
            </>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ProjectEvents;
